<template>
    <section class="legal-page py-5">
        <b-container>
            <h1 class="jd-text-dark jd-font-bold jd-text-36 jd-text-25__mobile text-center">Terms of Use</h1>

            <p class="jd-text-18 jd-text-dark mt-4">
                Please read these Terms of Use ("Terms", "Terms of Use") carefully before using the
                <a href="https://www.junkdeal.com" target="_blank" rel="noopener noreferrer">https://www.junkdeal.com</a>
                website (the "Service") operated by Junk Deal ("us", "we", or "our").
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                Your access to and use of the Service is conditioned on your acceptance of and compliance with these
                Terms. These Terms apply to all visitors, users and others who access or use the Service.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part
                of the terms then you may not access the Service.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Intellectual Property</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                The Service and its original content, features and functionality are and will remain the exclusive
                property of Junk Deal and its licensors.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Links To Other Web Sites</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                Our Service may contain links to third-party web sites or services that are not owned or controlled by
                Junk Deal.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                Junk Deal has no control over, and assumes no responsibility for, the content, privacy policies, or
                practices of any third party web sites or services. You further acknowledge and agree that Junk Deal
                shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged
                to be caused by or in connection with use of or reliance on any such content, goods or services
                available on or through any such web sites or services.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                We strongly advise you to read the terms and conditions and privacy policies of any third-party web
                sites or services that you visit.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Termination</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                We may terminate or suspend access to our Service immediately, without prior notice or liability, for
                any reason whatsoever, including without limitation if you breach the Terms.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                All provisions of the Terms which by their nature should survive termination shall survive termination,
                including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of
                liability.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Disclaimer</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE"
                basis. The Service is provided without warranties of any kind, whether express or implied, including,
                but not limited to, implied warranties of merchantability, fitness for a particular purpose,
                non-infringement or course of performance.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Governing Law</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                These Terms shall be governed and construed in accordance with the laws of the United States without
                regard to its conflict of law provisions.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                Our failure to enforce any right or provision of these Terms will not be considered a waiver of those
                rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the
                remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement
                between us regarding our Service, and supersede and replace any prior agreements we might have between
                us regarding the Service.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Changes</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a
                revision is material we will try to provide at least 30 days notice prior to any new terms taking
                effect. What constitutes a material change will be determined at our sole discretion.
            </p>
            <p class="jd-text-18 jd-text-dark mt-2">
                By continuing to access or use our Service after those revisions become effective, you agree to be
                bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
            </p>

            <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Contact Us</h2>
            <p class="jd-text-18 jd-text-dark mt-2">
                If you have any questions about these Terms, please contact us at
                <a href="mailto:info@junkdeal.com">info@junkdeal.com</a>.
            </p>
        </b-container>
    </section>
</template>

<script>
export default {
    metaInfo() {
        return {
            titleTemplate: '%s',
            title: 'Terms of Use',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Junk Deal Terms of Use'
                }
            ]
        };
    },
    mounted() {
        this.$root.$emit('hideLoader');
    }
}
</script>
